import { useState } from 'react';
import { ArrowRight, Loader2 } from 'lucide-react';

interface ApproveAnimatedButtonProps {
  onClick: () => Promise<unknown>;
}

export function ApproveAnimatedButton({ onClick }: ApproveAnimatedButtonProps) {
  const [phase, setPhase] = useState<'IDLE' | 'ARROW' | 'LOADING'>('IDLE');

  const handleClick = async () => {
    if (phase !== 'IDLE') return;
    setPhase('ARROW');
    setTimeout(async () => {
      setPhase('LOADING');
      await onClick();
    }, 400); 
  };

  return (
    <button
      onClick={handleClick}
      disabled={phase !== 'IDLE'}
      className="relative w-full bg-[#021B55] text-sm tracking-wider text-white py-4 rounded-xl font-semibold shadow-[0px_4px_4px_0px_#00000040,inset_6px_2px_4px_0px_#022577] overflow-hidden h-[56px] transition-transform active:scale-[0.98]"
    >
      <div className="absolute inset-0 flex items-center justify-center w-full h-full">
        <div className={`absolute transition-opacity duration-300 ${phase === 'LOADING' ? 'opacity-100' : 'opacity-0'}`}>
          <Loader2 className="w-6 h-6 animate-spin text-white" />
        </div>
        <div 
          className={`flex items-center justify-between w-full px-6 transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] ${
            phase === 'LOADING' ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
          }`}
        >
          <span className={`transform transition-transform duration-300 ${phase === 'ARROW' ? '-translate-x-2' : 'translate-x-0'}`}>
            APPROVE
          </span>
          <ArrowRight 
            className={`w-5 h-5 transform transition-all duration-300 ${
              phase === 'IDLE' ? 'opacity-0 translate-x-4' : 'opacity-100 translate-x-0'
            }`} 
          />
        </div>
      </div>
    </button>
  );
}